import { render } from "./LeftMenu.vue?vue&type=template&id=65282c18&scoped=true"
import script from "./LeftMenu.vue?vue&type=script&lang=js"
export * from "./LeftMenu.vue?vue&type=script&lang=js"

import "./LeftMenu.vue?vue&type=style&index=0&id=65282c18&lang=scss&scoped=true"

import exportComponent from "/Users/admin/Documents/Works/fast_energy_task_manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65282c18"]])

export default __exports__